/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskProcessStatusType } from './ExecRiskProcessStatusType';
import {
    ExecRiskProcessStatusTypeFromJSON,
    ExecRiskProcessStatusTypeFromJSONTyped,
    ExecRiskProcessStatusTypeToJSON,
} from './ExecRiskProcessStatusType';

/**
 * 
 * @export
 * @interface ExecRiskStatus
 */
export interface ExecRiskStatus {
    /**
     * 
     * @type {ExecRiskProcessStatusType}
     * @memberof ExecRiskStatus
     */
    status: ExecRiskProcessStatusType;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskStatus
     */
    started: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskStatus
     */
    finished?: string;
}

/**
 * Check if a given object implements the ExecRiskStatus interface.
 */
export function instanceOfExecRiskStatus(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "started" in value;

    return isInstance;
}

export function ExecRiskStatusFromJSON(json: any): ExecRiskStatus {
    return ExecRiskStatusFromJSONTyped(json, false);
}

export function ExecRiskStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': ExecRiskProcessStatusTypeFromJSON(json['status']),
        'started': json['started'],
        'finished': !exists(json, 'finished') ? undefined : json['finished'],
    };
}

export function ExecRiskStatusToJSON(value?: ExecRiskStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': ExecRiskProcessStatusTypeToJSON(value.status),
        'started': value.started,
        'finished': value.finished,
    };
}

